import React from 'react'
import './Login.css'
import logo1 from '../images/cta-logo-one.svg'
import logo2 from '../images/cta-logo-two.png'
function Login() {
  return (
   <>
   <section>
   <div className='container'>
    <div className='content'>
     <div className='header-img'>
        <img src={logo1} alt="" />
        <div className='signup'>
        GET ALL THERE
     </div>
     <p>
            Get Premier Access to Raya and the Last Dragon for an additional fee
            with a Disney+ subscription. As of 03/26/21, the price of Disney+
            and The Disney Bundle will increase by $1.
        </p>
        
        <img src={logo2} alt="" />
     </div>

    </div>
   </div>
   </section>
   </>
  )
}

export default Login;
